import Auth from '../../utils/Auth'

module.exports = [
  {
    // path: 'app',
    getChildRoutes(partialNextState, cb) {
      require.ensure([], require => {
        cb(null, [
          ...require('./routes/glasses-list'),
          ...require('./routes/glasses-group'),
          ...require('./routes/glasses-group-detail'),
          ...require('./routes/glasses-detail'),
          ...require('./routes/profile'),
          ...require('./routes/payment'),
          ...require('./routes/checkout'),
          ...require('./routes/dashboard'),
          ...require('./routes/brand'),
          ...require('./routes/shop-locator'),
          ...require('./routes/shop-locale'),
          ...require('./routes/invoice'),
          ...require('./routes/delegate-list'),
          ...require('./routes/try-on-builder'),
          ...require('./routes/lens-list'),
          ...require('./routes/pd-measurement'),
          ...require('./routes/template')
        ])
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./components/MainApp'))
      })
    }
  },
  {
    getChildRoutes(partialNextState, cb) {
      require.ensure([], require => {
        cb(null, [...require('./routes/stores')])
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./components/MainAppNoSideNav'))
      })
    }
  },
  {
    getChildRoutes(partialNextState, cb) {
      require.ensure([], require => {
        cb(null, [...require('./routes/thema')])
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./components/MainAppThema'))
      })
    }
  },
  {
    path: 'pricing',
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./routes/payment/components/UpgradeList'))
      })
    }
  },
  {
    path: 'stores',
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./routes/attention/components/Attention'))
      })
    }
  },
  {
    path: 'glasses-detail/:storeId/:id',
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('./routes/attention/components/Attention'))
      })
    }
  },
  {
    getChildRoutes(partialNextState, cb) {
      require.ensure([], () => {
        cb(null, {
          path: 'profile/:id',
          onEnter: Auth.redirectAdminToLogin,
          getComponent(nextState, _cb) {
            require.ensure([], require => {
              _cb(null, require('../app/routes/profile/components/Profile'))
            })
          }
        })
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('../admin/components/MainApp'))
      })
    }
  },
  {
    getChildRoutes(partialNextState, cb) {
      require.ensure([], () => {
        cb(null, {
          path: 'billing/:id',
          onEnter: Auth.redirectAdminToLogin,
          getComponent(nextState, _cb) {
            require.ensure([], require => {
              _cb(null, require('../app/routes/invoice/components/Invoice'))
            })
          }
        })
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('../admin/components/MainApp'))
      })
    }
  },
  {
    getChildRoutes(partialNextState, cb) {
      require.ensure([], () => {
        cb(null, {
          path: 'dashboard/:userId',
          onEnter: Auth.redirectAdminToLogin,
          getComponent(nextState, _cb) {
            require.ensure([], require => {
              _cb(null, require('../app/routes/dashboard/routes/TryOnAnalytics/components/Dashboard_v2'))
            })
          }
        })
      })
    },
    getComponent(nextState, cb) {
      require.ensure([], require => {
        cb(null, require('../admin/components/MainApp'))
      })
    }
  }
]



// WEBPACK FOOTER //
// ./routes/app/index.js